import React, { useState } from "react";

import { ActionIcon } from "@mantine/core";
import { IconCopy, IconEye, IconEyeOff } from "@tabler/icons-react";

import PreBox from "./PreBox";
import ButtonWithPopoverFeedback from "./ButtonWithPopoverFeedback";

function InfoRow({ label, value, revealable = false }) {
	const [hovered, setHovered] = useState(false);
	const [revealed, setRevealed] = useState(false);

	const displayValue =
		revealable && !revealed ? "•".repeat((value ?? "").length) : value;

	return (
		<div style={{ marginBottom: 12 }}>
			<div
				style={{
					fontFamily: "MainFont-Bold",
					marginBottom: 4,
					fontSize: 13,
				}}
			>
				{label}
			</div>
			<div
				style={{ display: "inline-block" }}
				onMouseEnter={() => setHovered(true)}
				onMouseLeave={() => setHovered(false)}
			>
				<PreBox
					style={{
						margin: 0,
						minWidth: 440,
						display: "inline-flex",
						alignItems: "center",
						gap: 8,
						fontFamily: "monospace",
					}}
				>
					<span style={{ flex: 1, fontFamily: "monospace" }}>
						{displayValue}
					</span>
					<div
						style={{
							visibility: hovered ? "visible" : "hidden",
							flexShrink: 0,
							display: "flex",
							gap: 4,
						}}
					>
						{revealable && (
							<ActionIcon
								variant="subtle"
								size="sm"
								title={revealed ? "Hide" : "Show"}
								onClick={() => setRevealed((r) => !r)}
							>
								{revealed ? (
									<IconEyeOff size={16} />
								) : (
									<IconEye size={16} />
								)}
							</ActionIcon>
						)}
						<ButtonWithPopoverFeedback
							iconComponent={<IconCopy size={16} />}
							onClick={() =>
								navigator.clipboard.writeText(value ?? "")
							}
							feedbackMessage="Copied to clipboard!"
							title="Copy to clipboard"
						/>
					</div>
				</PreBox>
			</div>
		</div>
	);
}

export default InfoRow;
